import { render, staticRenderFns } from "./categoryPageNavi.vue?vue&type=template&id=61945883&scoped=true&"
import script from "./categoryPageNavi.vue?vue&type=script&lang=ts&"
export * from "./categoryPageNavi.vue?vue&type=script&lang=ts&"
import style0 from "./categoryPageNavi.vue?vue&type=style&index=0&id=61945883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61945883",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61945883', component.options)
    } else {
      api.reload('61945883', component.options)
    }
    module.hot.accept("./categoryPageNavi.vue?vue&type=template&id=61945883&scoped=true&", function () {
      api.rerender('61945883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/categoryPageNavi.vue"
export default component.exports